import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

export const useDeleteInviteLinkMutation = (): MutationState => {
  const companyId = useCompanyId();

  return useMutation({
    request: {
      type: 'rest',
      method: 'delete',
      target: 'companyAPI',
      endpoint: '/invite-links',
    },
    options: {
      onSuccess: ({ client }) => {
        client.invalidateQueries(['inviteLink', companyId]);
      },
    },
  });
};
